import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Button,
    MenuItem,
    Select,
    TextField,
    FormControl,
    InputLabel,
    IconButton,
    Typography,
    Alert
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';

import { useResendDocument } from '@features/digitalOnboarding/hooks/useResendDocument';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useUpdatePayrate } from '../hooks/useUpdatePayrate';
import { EditIcon } from '../../../vectors/index';

type PayrateEditModalProps = {
    handleClose: () => void;
    item: any;
};

const PayrateEditModal: FC<PayrateEditModalProps> = ({
    handleClose,
    item,
}) => {

    const [payRateType, setPayRateType] = useState(item.pay_rate_type || '');
    const [payRate, setPayRate] = useState(item.pay_rate || '');
    const [errorText, setErrorText] = useState('')

    const { updatePayrate, isUpdatePayrateLoading } = useUpdatePayrate({ setErrorText })

    const handleSave = () => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message)
                handleClose();
            },
        };
        updatePayrate({
            application_id: item.id,
            pay_rate_type: payRateType,
            pay_rate: payRate,
        }, options)
    };

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <EditIcon />
                <br />
                <Typography variant="h4" sx={{ p: 3 }}>
                    <b>{item.applicant.s_name}</b>-  Payrate
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={2}>
                    {errorText && <Alert severity="error">{errorText}</Alert>}
                    <FormControl fullWidth>
                        <Typography id="pay-rate-type-label">Pay Rate Type</Typography>
                        <Select
                            labelId="pay-rate-type-label"
                            value={payRateType}
                            onChange={(e) => setPayRateType(e.target.value)}
                            size='small'
                            sx={{ width: "100%" }}
                            MenuProps={{ PaperProps: { style: { borderRadius: 5 } } }}
                        >
                            <MenuItem value="Hourly">Hourly</MenuItem>
                            <MenuItem value="Salary">Salary</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <Typography id="pay-rate-type-label">Pay Rate</Typography>
                        <TextField
                            variant="outlined"
                            value={payRate}
                            onChange={(e) => setPayRate(e.target.value)}
                            fullWidth
                            size='small'
                        />
                    </FormControl>

                    <LoadingButton
                        loading={isUpdatePayrateLoading}
                        disabled={isUpdatePayrateLoading || !payRateType || !payRate}
                        startIcon={<DoneIcon />} variant="contained" color="primary" onClick={handleSave}>
                        Save
                    </LoadingButton>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default PayrateEditModal;
